import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { clearStatusColumns } from "../../../../constants/lineListColumns";
import { CLIENTS, OPERATIONS } from "../../../../constants/value";
import { __getReset } from "../../../../api/sim";

const COPY_KEYS = ["id", "iccid", "status", "created_at", "last_updated"];

const ClearStatusBatch = () => (
  <BatchDetail
    title="Clear Status"
    apiGet={__getReset}
    client={CLIENTS.tmobilej}
    columnsFactory={clearStatusColumns}
    copyKeys={COPY_KEYS}
    exportAction={OPERATIONS.clear_status}
    retryOperation={OPERATIONS.clear_status}
    showTerminate
    terminateOperation={OPERATIONS.clear_status}
    getRowPath={(row) => `/tmobilej/clear_status/${row.id}`}
  />
);

export default ClearStatusBatch;
